import { render, staticRenderFns } from "./voteRecordList.vue?vue&type=template&id=2fa0fd08&"
import script from "./voteRecordList.vue?vue&type=script&lang=js&"
export * from "./voteRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports